/**
 * Created by Administrator on 2017/12/7.
 */
import leftNavBar from './left-navbar.vue';
import header from './header.vue'

export default {
  leftNavBar, header,
}



// WEBPACK FOOTER //
// ./src/components/index.js